export default "__VITE_ASSET__Dk6qM19f__$_?nuxt_component=async&nuxt_component_name=IconFacebook&nuxt_component_export=default__"